<template>
  <div>
    <validation-provider
      #default="{ errors }"
      name="company"
      :rules="requiredField ? 'required' : ''"
    >
      <b-form-group
        label="Empresa"
        label-for="company"
      >
        <v-select
          id="company"
          v-model="company"
          :class="errors.length > 0 ? 'error-select' : ''"
          :filter="fuseSearch"
          label="name_fantasy"
          :options="dataOptions"
          :placeholder="'Empresa'"
          :disabled="readonly"
          :clearable="!readonly"
          @open="onCreate()"
        >
          <template #option="{ name_fantasy }">
            <span>{{ name_fantasy }}</span>
          </template>

          <template #selected-option="{ name_fantasy }">
            <span>{{ name_fantasy | truncate(truncateField, '...') }}</span>
          </template>

          <template #no-options>
            Não há opções de empresas.
          </template>
        </v-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </b-form-group>
    </validation-provider>
  </div>
</template>
<script>
import {
  BFormGroup,
} from 'bootstrap-vue'

import {
  ValidationProvider,
} from 'vee-validate'

import {
  required,
} from '@validations'

import vSelect from 'vue-select'
import Fuse from 'fuse.js'
import truncate from '@/components/utils/filters/truncate'
import syslic from '@/syslic'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  filters: {
    truncate,
  },
  model: {
    prop: 'companyValue',
    event: 'companyChange',
  },
  props: {
    companyValue: {
      type: [Object, String],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: false,
    },
    truncateField: {
      type: Number,
      required: false,
      default: 17,
    },
  },
  data() {
    const dataOptions = []
    const newCompanyValue = this.companyValue

    return {
      dataOptions,
      newCompanyValue,
      required,
    }
  },
  computed: {
    company: {
      get() {
        return this.newCompanyValue
      },
      set(value) {
        this.newCompanyValue = value
        this.$emit('companyChange', this.newCompanyValue)
      },
    },
  },
  watch: {
    companyValue(newVal) {
      this.newCompanyValue = newVal
    },
  },
  created() {
    this.onCreate()
  },
  methods: {
    onCreate() {
      syslic
        .company
        .fetchCompanyList()
        .then(response => {
          this.dataOptions = response.data.results
          this.$emit('ready', true)
        })
        .catch(() => {
          this.$emit('ready', true)
        })
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['name_fantasy', 'cnpj'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss" scoped>
.v-select {
  background-color: #fff;
}

#vs3__listbox {
  background-color: red !important;
  color: green !important;
}
</style>
